export const WarningSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115439_298323)">
      <path
        d="M4.39182 25.6018C2.95917 24.2181 1.81644 22.563 1.0303 20.7329C0.244167 18.9028 -0.169626 16.9345 -0.186934 14.9428C-0.204241 12.9512 0.175285 10.976 0.929498 9.13251C1.68371 7.28907 2.79751 5.61429 4.2059 4.2059C5.61429 2.79751 7.28907 1.68371 9.13251 0.929498C10.976 0.175285 12.9512 -0.204241 14.9428 -0.186934C16.9345 -0.169626 18.9028 0.244167 20.7329 1.0303C22.563 1.81644 24.2181 2.95917 25.6018 4.39182C28.3342 7.22086 29.8461 11.0099 29.8119 14.9428C29.7778 18.8758 28.2002 22.638 25.4191 25.4191C22.638 28.2002 18.8758 29.7778 14.9428 29.8119C11.0099 29.8461 7.22086 28.3342 4.39182 25.6018ZM17.0968 14.9968L21.3418 10.7518L19.2268 8.63682L14.9968 12.8818L10.7518 8.63682L8.63682 10.7518L12.8818 14.9968L8.63682 19.2418L10.7518 21.3568L14.9968 17.1118L19.2418 21.3568L21.3568 19.2418L17.1118 14.9968H17.0968Z"
        fill="#DC2626"
      />
    </g>
    <defs>
      <clipPath id="clip0_115439_298323">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SuccessSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9037 2.5 27.5 8.09625 27.5 15C27.5 21.9037 21.9037 27.5 15 27.5ZM13.5287 17.675L10.0725 14.2163L8.75 15.5387L12.6488 19.44C12.8832 19.6743 13.201 19.806 13.5325 19.806C13.864 19.806 14.1818 19.6743 14.4162 19.44L21.8563 12.0025L20.5288 10.675L13.5287 17.675Z"
      fill="#2CA87F"
    />
  </svg>
);

export const DelaySVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 24.9996C20 24.343 19.8189 23.6929 19.4672 23.0863C19.1154 22.4798 18.5998 21.9286 17.9497 21.4643C17.2997 21.0001 16.5281 20.6318 15.6788 20.3806C14.8295 20.1293 13.9193 20 13 20C12.0807 20 11.1705 20.1293 10.3212 20.3806C9.47194 20.6318 8.70026 21.0001 8.05025 21.4643C7.40024 21.9286 6.88463 22.4798 6.53284 23.0863C6.18106 23.6929 6 24.343 6 24.9996L13 24.9996H20Z"
      fill="black"
    />
    <ellipse cx="12.75" cy="17.9474" rx="0.75" ry="0.681763" fill="black" />
    <ellipse cx="12.75" cy="15.2286" rx="0.75" ry="0.681763" fill="black" />
    <path
      d="M15.3469 7.51904C9.80548 5.85988 7 7.42771 7 7.51904C7 7.61037 11.0743 10.1777 11.6569 11.3477C12.2395 12.5176 11.8511 12.7303 12.628 12.7303C13.3986 12.7303 13.5091 12.1984 13.6601 11.4716L13.6637 11.454C13.9915 9.87696 18.3247 8.37028 18.8426 7.14718C19.2569 6.16869 18.7563 6.31405 18.4542 6.50904C17.0559 7.65769 15.8 7.66098 15.3469 7.51904Z"
      fill="black"
      stroke="black"
    />
    <rect y="26.3672" width="27" height="2.72705" rx="1.36353" fill="#1D1A22" />
    <rect width="27" height="2.72705" rx="1.36353" fill="#1D1A22" />
    <path
      d="M3.19914 2.71875C3.07401 4.12656 3.2388 7.0046 4.55618 9.20901C5.22081 10.3211 6.67021 11.2449 7.73656 11.9807V11.9807C10.5667 13.9336 9.92149 16.93 7.02321 18.7803C6.64248 19.0233 6.22983 19.2712 5.78349 19.5216C4.55651 20.3607 2.32184 23.0835 3.19896 27.2622"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M22.7854 2.71875C22.927 4.13391 22.7387 7.03469 21.2337 9.24348C20.4814 10.3475 19.2779 11.0203 18.1308 11.7052C17.8983 11.8441 17.6629 11.9873 17.4285 12.133C14.7046 13.8272 14.2432 16.0081 16.9003 17.8053V17.8053C18.1668 18.6619 20.5513 19.9475 21.481 21.1615C22.5261 22.5263 23.426 24.553 22.7856 27.2622"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);

export const RoleSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115439_296815)">
      <g clipPath="url(#clip1_115439_296815)">
        <g clipPath="url(#clip2_115439_296815)">
          <path
            d="M17.1016 3.01067C16.9564 2.38427 16.5947 1.82926 16.0802 1.4436C15.5657 1.05795 14.9315 0.866416 14.2895 0.902814C13.6475 0.939213 13.039 1.2012 12.5714 1.64254C12.1038 2.08389 11.8071 2.67622 11.7336 3.31502C11.6602 3.95382 11.8148 4.59803 12.1701 5.13397C12.5254 5.6699 13.0585 6.06312 13.6755 6.24424C14.2925 6.42535 14.9536 6.38271 15.5422 6.12386C16.1308 5.865 16.609 5.40655 16.8925 4.82942C18.6184 5.22243 20.2228 6.02938 21.5673 7.18067C22.9118 8.33196 23.9561 9.79302 24.61 11.4379L26.2741 10.7835C25.5038 8.83254 24.2634 7.10214 22.6632 5.74611C21.063 4.39008 19.1525 3.45042 17.1016 3.01067ZM14.456 4.5463C14.3342 4.55021 14.2128 4.5296 14.0991 4.48568C13.9854 4.44176 13.8817 4.37544 13.7942 4.29066C13.7066 4.20587 13.637 4.10435 13.5895 3.99213C13.5419 3.8799 13.5174 3.75927 13.5174 3.63739C13.5174 3.51551 13.5419 3.39488 13.5895 3.28266C13.637 3.17043 13.7066 3.06891 13.7942 2.98413C13.8817 2.89934 13.9854 2.83302 14.0991 2.7891C14.2128 2.74519 14.3342 2.72457 14.456 2.72848C14.6972 2.72848 14.9285 2.82429 15.099 2.99483C15.2696 3.16538 15.3654 3.39668 15.3654 3.63786C15.3654 3.87904 15.2696 4.11034 15.099 4.28088C14.9285 4.45143 14.6972 4.5463 14.456 4.5463ZM10.4557 5.30192L9.78348 3.6388C7.83254 4.4091 6.10214 5.64949 4.74611 7.24971C3.39008 8.84993 2.45042 10.7604 2.01067 12.8113C1.38427 12.9565 0.829264 13.3182 0.443605 13.8327C0.0579452 14.3472 -0.133584 14.9814 -0.0971857 15.6234C-0.0607873 16.2654 0.201199 16.8739 0.642544 17.3415C1.08389 17.8091 1.67622 18.1058 2.31502 18.1793C2.95382 18.2527 3.59803 18.0981 4.13397 17.7428C4.6699 17.3876 5.06312 16.8544 5.24424 16.2374C5.42535 15.6204 5.38271 14.9593 5.12386 14.3707C4.865 13.7821 4.40655 13.3039 3.82942 13.0204C4.22405 11.2924 5.03363 9.68662 6.18816 8.3418C7.34268 6.99698 8.8074 5.95361 10.4557 5.30192ZM2.63692 16.3663C2.5175 16.3663 2.39925 16.3428 2.28892 16.2971C2.17859 16.2514 2.07834 16.1844 1.9939 16.0999C1.90945 16.0155 1.84247 15.9153 1.79677 15.8049C1.75107 15.6946 1.72755 15.5763 1.72755 15.4569C1.72755 15.3375 1.75107 15.2192 1.79677 15.1089C1.84247 14.9986 1.90945 14.8983 1.9939 14.8139C2.07834 14.7295 2.17859 14.6625 2.28892 14.6168C2.39925 14.5711 2.5175 14.5475 2.63692 14.5475C2.8781 14.5475 3.10941 14.6434 3.27995 14.8139C3.45049 14.9844 3.5463 15.2157 3.5463 15.4569C3.5463 15.6981 3.45049 15.9294 3.27995 16.0999C3.10941 16.2705 2.8781 16.3663 2.63692 16.3663ZM14.456 24.5479C13.9488 24.5495 13.4522 24.6925 13.0217 24.9608C12.5913 25.2291 12.2442 25.612 12.0194 26.0666C10.2933 25.6736 8.68863 24.8666 7.34395 23.7151C5.99926 22.5637 4.95491 21.1024 4.30098 19.4572L2.63786 20.1294C3.41067 22.0837 4.65521 23.8162 6.26046 25.1725C7.8657 26.5287 9.78171 27.4666 11.8375 27.9022C11.9556 28.4027 12.2128 28.8597 12.5793 29.2203C12.9459 29.581 13.4069 29.8307 13.9093 29.9407C14.4116 30.0507 14.9348 30.0165 15.4186 29.842C15.9023 29.6675 16.3268 29.3598 16.6433 28.9544C16.9597 28.5491 17.1551 28.0625 17.207 27.5509C17.2588 27.0393 17.1651 26.5234 16.9364 26.0628C16.7078 25.6022 16.3536 25.2155 15.9147 24.9475C15.4759 24.6795 14.9702 24.5409 14.456 24.5479ZM14.456 28.1844C14.2148 28.1844 13.9835 28.0886 13.813 27.9181C13.6424 27.7475 13.5466 27.5162 13.5466 27.275C13.5466 27.0339 13.6424 26.8026 13.813 26.632C13.9835 26.4615 14.2148 26.3657 14.456 26.3657C14.6972 26.3657 14.9285 26.4615 15.099 26.632C15.2696 26.8026 15.3654 27.0339 15.3654 27.275C15.3654 27.5162 15.2696 27.7475 15.099 27.9181C14.9285 28.0886 14.6972 28.1844 14.456 28.1844ZM29.0013 15.456C29.003 14.9692 28.8744 14.4909 28.6288 14.0706C28.3833 13.6503 28.0298 13.3033 27.605 13.0657C27.1801 12.8281 26.6995 12.7084 26.2128 12.7192C25.7262 12.73 25.2513 12.8708 24.8374 13.1269C24.4235 13.3831 24.0857 13.7454 23.859 14.1761C23.6323 14.6069 23.525 15.0905 23.5482 15.5767C23.5714 16.0629 23.7242 16.534 23.9909 16.9413C24.2576 17.3485 24.6283 17.6769 25.0647 17.8925C24.6716 19.6185 23.8645 21.223 22.7131 22.5675C21.5616 23.912 20.1004 24.9562 18.4554 25.61L19.1285 27.2741C21.0827 26.5013 22.8153 25.2568 24.1715 23.6515C25.5278 22.0463 26.4656 20.1303 26.9013 18.0744C27.4931 17.9345 28.0212 17.6008 28.4016 17.1264C28.7821 16.652 28.9932 16.0641 29.0013 15.456ZM26.2732 16.3654C26.032 16.3654 25.8007 16.2696 25.6301 16.099C25.4596 15.9285 25.3638 15.6972 25.3638 15.456C25.3638 15.2148 25.4596 14.9835 25.6301 14.813C25.8007 14.6424 26.032 14.5466 26.2732 14.5466C26.5144 14.5466 26.7457 14.6424 26.9162 14.813C27.0867 14.9835 27.1825 15.2148 27.1825 15.456C27.1825 15.6972 27.0867 15.9285 26.9162 16.099C26.7457 16.2696 26.5144 16.3654 26.2732 16.3654Z"
            fill="#964B00"
          />
          <path
            d="M16.9881 15.3244C17.5054 14.8193 17.8603 14.1715 18.0077 13.4638C18.1551 12.756 18.0881 12.0204 17.8155 11.3509C17.5428 10.6813 17.0768 10.1083 16.4769 9.70484C15.877 9.30141 15.1704 9.08594 14.4475 9.08594C13.7246 9.08594 13.018 9.30141 12.4181 9.70484C11.8182 10.1083 11.3522 10.6813 11.0795 11.3509C10.8069 12.0204 10.7399 12.756 10.8873 13.4638C11.0347 14.1715 11.3896 14.8193 11.9069 15.3244C11.2913 15.7404 10.7871 16.301 10.4384 16.957C10.0896 17.6131 9.90689 18.3445 9.90625 19.0875V20.9053H18.9972V19.0866C18.9956 18.3428 18.8116 17.6109 18.4614 16.9548C18.1111 16.2987 17.6052 15.7395 16.9881 15.3244ZM12.6334 12.7228C12.6334 12.484 12.6805 12.2475 12.7719 12.0268C12.8633 11.8062 12.9973 11.6057 13.1661 11.4368C13.335 11.2679 13.5355 11.1339 13.7562 11.0425C13.9768 10.9511 14.2133 10.9041 14.4522 10.9041C14.691 10.9041 14.9275 10.9511 15.1482 11.0425C15.3689 11.1339 15.5694 11.2679 15.7382 11.4368C15.9071 11.6057 16.0411 11.8062 16.1325 12.0268C16.2239 12.2475 16.2709 12.484 16.2709 12.7228C16.2709 13.2052 16.0793 13.6678 15.7382 14.0089C15.3972 14.35 14.9346 14.5416 14.4522 14.5416C13.9698 14.5416 13.5072 14.35 13.1661 14.0089C12.8251 13.6678 12.6334 13.2052 12.6334 12.7228ZM11.7241 19.0866C11.7173 18.7241 11.7829 18.364 11.917 18.0271C12.051 17.6903 12.2509 17.3836 12.5048 17.1249C12.7588 16.8662 13.0618 16.6607 13.396 16.5204C13.7303 16.3801 14.0892 16.3079 14.4517 16.3079C14.8142 16.3079 15.1731 16.3801 15.5074 16.5204C15.8417 16.6607 16.1446 16.8662 16.3986 17.1249C16.6525 17.3836 16.8524 17.6903 16.9864 18.0271C17.1205 18.364 17.1861 18.7241 17.1794 19.0866H11.7241Z"
            fill="#964B00"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_115439_296815">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_115439_296815">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip2_115439_296815">
        <rect width="30" height="30" fill="white" transform="translate(-1)" />
      </clipPath>
    </defs>
  </svg>
);

export const InProcessSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115439_298327)">
      <path
        d="M14.9974 1.66406C12.3603 1.66406 9.78245 2.44605 7.5898 3.91113C5.39714 5.37622 3.68818 7.4586 2.67901 9.89495C1.66984 12.3313 1.4058 15.0122 1.92026 17.5986C2.43473 20.185 3.70461 22.5608 5.56931 24.4255C7.43401 26.2902 9.80979 27.5601 12.3962 28.0745C14.9826 28.589 17.6635 28.325 20.0998 27.3158C22.5362 26.3066 24.6186 24.5977 26.0837 22.405C27.5488 20.2123 28.3307 17.6345 28.3307 14.9974C28.3307 11.4612 26.926 8.06979 24.4255 5.56931C21.925 3.06882 18.5336 1.66406 14.9974 1.66406ZM14.9974 26.6641C12.69 26.6641 10.4343 25.9798 8.51575 24.6979C6.59718 23.4159 5.10183 21.5938 4.21881 19.462C3.33579 17.3302 3.10475 14.9845 3.55491 12.7213C4.00507 10.4582 5.11621 8.37943 6.74782 6.74782C8.37944 5.1162 10.4582 4.00506 12.7213 3.5549C14.9845 3.10474 17.3302 3.33578 19.462 4.2188C21.5938 5.10182 23.4159 6.59717 24.6979 8.51574C25.9798 10.4343 26.6641 12.6899 26.6641 14.9974C26.6641 18.0916 25.4349 21.0591 23.247 23.247C21.0591 25.4349 18.0916 26.6641 14.9974 26.6641Z"
        fill="#F99D00"
      />
      <path
        d="M15.7682 15.3333V8.95833C15.7682 8.73732 15.6804 8.52536 15.5242 8.36908C15.3679 8.2128 15.1559 8.125 14.9349 8.125C14.7139 8.125 14.5019 8.2128 14.3456 8.36908C14.1894 8.52536 14.1016 8.73732 14.1016 8.95833V16.225L19.0182 19.5583C19.1088 19.6265 19.2123 19.6754 19.3224 19.7021C19.4326 19.7289 19.547 19.7329 19.6587 19.7139C19.7704 19.6949 19.8771 19.6534 19.9722 19.5918C20.0673 19.5301 20.1489 19.4498 20.2119 19.3556C20.2749 19.2614 20.318 19.1553 20.3386 19.0439C20.3592 18.9324 20.3568 18.818 20.3317 18.7074C20.3066 18.5969 20.2591 18.4927 20.1923 18.4012C20.1255 18.3096 20.0408 18.2327 19.9432 18.175L15.7682 15.3333Z"
        fill="#F99D00"
      />
      <path
        d="M6.66936 14.9465C6.66174 13.4474 7.06111 11.9743 7.82489 10.6843C8.58867 9.39428 9.68822 8.33574 11.0063 7.62152C12.3244 6.90731 13.8116 6.56419 15.3094 6.62877C16.8071 6.69334 18.2593 7.16318 19.511 7.98818L20.2194 6.85485C19.0304 6.07602 17.6837 5.57018 16.276 5.37368C14.8683 5.17717 13.4345 5.29488 12.0777 5.71835C10.7209 6.14181 9.47475 6.86052 8.42872 7.82284C7.38269 8.78517 6.56278 9.96722 6.02789 11.2841C5.49299 12.6009 5.25639 14.0199 5.33507 15.4391C5.41376 16.8583 5.80578 18.2424 6.48298 19.492C7.16018 20.7417 8.10574 21.8259 9.25174 22.6666C10.3977 23.5074 11.7157 24.084 13.111 24.3548L13.336 23.0798C11.4593 22.6968 9.77191 21.6789 8.5577 20.1976C7.34349 18.7163 6.67663 16.8619 6.66936 14.9465Z"
        fill="#F99D00"
      />
    </g>
    <defs>
      <clipPath id="clip0_115439_298327">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ApprovalSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.75 14.9969L25.7 11.5219L26.125 6.92188L21.6125 5.89687L19.25 1.92188L15 3.74688L10.75 1.92188L8.3875 5.89687L3.875 6.90938L4.3 11.5094L1.25 14.9969L4.3 18.4719L3.875 23.0844L8.3875 24.1094L10.75 28.0844L15 26.2469L19.25 28.0719L21.6125 24.0969L26.125 23.0719L25.7 18.4719L28.75 14.9969ZM12.5 21.2469L7.5 16.2469L9.2625 14.4844L12.5 17.7094L20.7375 9.47187L22.5 11.2469L12.5 21.2469Z"
      fill="#4680FF"
    />
  </svg>
);

export const WaitingSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1412 4.54933C12.8675 3.93058 13.2312 3.62058 13.6112 3.43933C14.0449 3.23239 14.5194 3.125 15 3.125C15.4805 3.125 15.955 3.23239 16.3887 3.43933C16.7687 3.62058 17.1325 3.93058 17.8587 4.54933C18.6075 5.18683 19.3675 5.50933 20.3675 5.58808C21.3187 5.66433 21.795 5.70308 22.1925 5.84308C23.11 6.16808 23.8325 6.88933 24.1562 7.80808C24.2962 8.20433 24.335 8.68058 24.4112 9.63308C24.49 10.6331 24.8112 11.3918 25.4487 12.1406C26.0687 12.8668 26.3787 13.2306 26.56 13.6106C26.98 14.4893 26.98 15.5106 26.56 16.3881C26.3787 16.7681 26.0687 17.1318 25.45 17.8581C24.8305 18.5531 24.4644 19.4373 24.4112 20.3668C24.335 21.3181 24.2962 21.7943 24.1562 22.1918C23.9957 22.6449 23.736 23.0564 23.396 23.3961C23.056 23.7359 22.6444 23.9954 22.1912 24.1556C21.795 24.2956 21.3187 24.3343 20.3662 24.4106C19.3662 24.4893 18.6075 24.8106 17.8587 25.4481C17.1325 26.0681 16.7687 26.3781 16.3887 26.5593C15.955 26.7663 15.4805 26.8737 15 26.8737C14.5194 26.8737 14.0449 26.7663 13.6112 26.5593C13.2312 26.3781 12.8675 26.0681 12.1412 25.4493C11.4461 24.8299 10.562 24.4638 9.63246 24.4106C8.68121 24.3343 8.20496 24.2956 7.80746 24.1556C7.35439 23.9951 6.94292 23.7353 6.60315 23.3954C6.26339 23.0554 6.00391 22.6438 5.84371 22.1906C5.70371 21.7943 5.66496 21.3181 5.58871 20.3656C5.53557 19.4367 5.16994 18.553 4.55121 17.8581C3.93121 17.1318 3.62121 16.7681 3.43871 16.3881C3.23196 15.9543 3.12478 15.4797 3.125 14.9992C3.12522 14.5186 3.23282 14.0442 3.43996 13.6106C3.62121 13.2306 3.93121 12.8668 4.54996 12.1406C5.19996 11.3768 5.51121 10.6118 5.58871 9.63183C5.66496 8.68058 5.70371 8.20433 5.84371 7.80683C6.0042 7.35376 6.26394 6.94229 6.60392 6.60253C6.9439 6.26276 7.35553 6.00329 7.80871 5.84308C8.20496 5.70308 8.68121 5.66433 9.63371 5.58808C10.5626 5.53494 11.4463 5.16806 12.1412 4.54933Z"
      stroke="#30B0C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 7.5V15L20 17.5"
      stroke="#30B0C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PendingSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM15 25C9.475 25 5 20.525 5 15C5 9.475 9.475 5 15 5C20.525 5 25 9.475 25 15C25 20.525 20.525 25 15 25Z"
      fill="#9FA2AA"
    />
    <path
      d="M8.75 16.875C9.78553 16.875 10.625 16.0355 10.625 15C10.625 13.9645 9.78553 13.125 8.75 13.125C7.71447 13.125 6.875 13.9645 6.875 15C6.875 16.0355 7.71447 16.875 8.75 16.875Z"
      fill="#9FA2AA"
    />
    <path
      d="M15 16.875C16.0355 16.875 16.875 16.0355 16.875 15C16.875 13.9645 16.0355 13.125 15 13.125C13.9645 13.125 13.125 13.9645 13.125 15C13.125 16.0355 13.9645 16.875 15 16.875Z"
      fill="#9FA2AA"
    />
    <path
      d="M21.25 16.875C22.2855 16.875 23.125 16.0355 23.125 15C23.125 13.9645 22.2855 13.125 21.25 13.125C20.2145 13.125 19.375 13.9645 19.375 15C19.375 16.0355 20.2145 16.875 21.25 16.875Z"
      fill="#9FA2AA"
    />
  </svg>
);

export const CompletedSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.29125 12.8125C9.29875 12.8125 10.2075 12.255 10.83 11.4625C11.7992 10.2235 13.0175 9.20147 14.4063 8.4625C15.31 7.9825 16.0938 7.2675 16.4725 6.31875C16.7385 5.65405 16.8751 4.94468 16.875 4.22875V3.4375C16.875 3.18886 16.9738 2.9504 17.1496 2.77459C17.3254 2.59877 17.5639 2.5 17.8125 2.5C18.5584 2.5 19.2738 2.79632 19.8012 3.32376C20.3287 3.85121 20.625 4.56658 20.625 5.3125C20.625 6.7525 20.3 8.11625 19.7213 9.335C19.3888 10.0325 19.855 10.9375 20.6275 10.9375M20.6275 10.9375H24.535C25.8175 10.9375 26.9663 11.805 27.1025 13.0813C27.1592 13.6088 27.1875 14.1442 27.1875 14.6875C27.1927 18.1079 26.0238 21.4265 23.8763 24.0887C23.3913 24.6912 22.6425 25 21.87 25H16.85C16.2455 25.0004 15.6449 24.9033 15.0713 24.7125L11.1788 23.4125C10.6051 23.2217 10.0045 23.1246 9.4 23.125H7.38C7.48417 23.3808 7.59667 23.6317 7.7175 23.8775C7.96375 24.3775 7.62 25 7.06375 25H5.92875C4.8175 25 3.7875 24.3525 3.46375 23.29C3.03081 21.8691 2.81133 20.3917 2.8125 18.9062C2.8125 16.965 3.18125 15.1113 3.85125 13.4088C4.23375 12.4413 5.20875 11.875 6.25 11.875H7.56625C8.15625 11.875 8.4975 12.57 8.19125 13.075C7.12374 14.8325 6.56066 16.85 6.56375 18.9062C6.56265 20.352 6.84021 21.7843 7.38126 23.125M20.6275 10.9375H17.8125"
      stroke="#3C0058"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Arrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9375 13.2787L10.2842 8.93208C10.7975 8.41875 10.7975 7.57875 10.2842 7.06542L5.9375 2.71875"
      stroke="#4680FF"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotificationSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M12 6.4375V9.7675"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.0189 2C8.33892 2 5.35892 4.98 5.35892 8.66V10.76C5.35892 11.44 5.07892 12.46 4.72892 13.04L3.45892 15.16C2.67892 16.47 3.21892 17.93 4.65892 18.41C9.43892 20 14.6089 20 19.3889 18.41C20.7389 17.96 21.3189 16.38 20.5889 15.16L19.3189 13.04C18.9689 12.46 18.6889 11.43 18.6889 10.76V8.66C18.6789 5 15.6789 2 12.0189 2Z"
      fill="white"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      opacity="0.4"
      d="M15.3319 18.8203C15.3319 20.6503 13.8319 22.1503 12.0019 22.1503C11.0919 22.1503 10.2519 21.7703 9.65187 21.1703C9.05187 20.5703 8.67188 19.7303 8.67188 18.8203"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
